<template>
  <div>
    <v-dialog />
    <div class="admin_title"><span v-if="params.title && params.title!=''">{{params.title}} -- </span>成绩一览</div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <select name="level" v-model="filter.isPassed" @change="searchByFilter(filter)">
        <option :value="''">全部(是否及格)</option>
        <option :value="'1'">及格</option>
        <option :value="'0'">不及格</option>
      </select>
    </div>
    <div class="add_shijuan_con">
      <table id="customers">
        <tr>
          <th width="16%">账号</th>
          <th width="14%">昵称</th>
          <th width="12%">分数</th>
          <th width="8%">考试状态</th>
          <th width="20%">考试开始时间</th>
          <th width="20%">考试提交时间</th>
          <th width="10%">操作</th>
        </tr>
        <tr v-for="item in list" :key="item.id">
          <td><span v-if="item.accountNames && item.accountNames!=''">{{JSON.parse(item.accountNames)[0]}}</span><span v-if="!item.accountNames || item.accountNames==''">暂无信息</span></td>
          <td><span v-if="item.nickName && item.nickName!=''">{{item.nickName}}</span> <span v-if="!item.nickName || item.nickName==''"></span></td>
          <td>{{item.score}}</td>
          <td><span v-if="item.isPassed=='0'">不及格</span><span v-if="item.isPassed=='1'">及格</span></td>
          <td>{{item.examStart}}</td>
          <td>{{item.examEnd}}</td>
          <td>
            <a href="javascript:;" class="red_font_a" @click="scoreByTeacher(item.id, item.paperId)">老师打分</a>
            <a href="javascript:;" class="red_font_a" @click="deleteScore(item.id)">删除</a>
          </td>
        </tr>
      </table>
    </div>
    <!--/右侧内容-->
    <div class="zy_list_bottom">
      <dl>
        <dt><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{cnt}}人次</dt>
        <dd>
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

import Dropdown from '@/store/modules/dropdowns'
import Paginate from 'vuejs-paginate'
import utils from '@/utils'
export default {
  components: { Paginate },
  data () {
    return {
      Dropdown: Dropdown,
      params: {},
      filter: {
        pageNo: 1,
        pageSize: 15,
        isPassed: '',
        paperId: this.$route.params.id,
        showPaperScoreList: '1'
      },
      list: [],
      pages: 0,
      cnt: 0,
      prefix: this.$route.meta.prefix || ''
    }
  },
  created () {
    this.getExamInfo(this.$route.params.id)
    this.getExamScore(this.filter)
  },
  mounted () {
    this.$nextTick(() => {})
  },
  computed: {},
  methods: {
    confirmBox (o) {
      var that = this
      this.$modal.show('dialog', {
        title: o.title,
        text: o.text,
        buttons: [
          {
            title: '确认',
            default: true,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getExamScore(this.filter)
    },
    searchByFilter (filter) {
      this.getExamScore(filter)
    },
    getExamScore (filter) {
      this.$api.post(this.$global.examApiPath, '/examExamScore/search', filter, r => {
        this.cnt = r.cntData
        this.pages = Math.ceil(r.cntData / this.filter.pageSize)
        this.list = r.data
      })
    },
    getExamInfo (id) {
      this.$api.post(this.$global.examApiPath, '/examPaper/get', {id: id}, r => {
        this.params = r.data[0]
      })
    },
    scoreByTeacher (examId, paperId) {
      this.$router.push({path: this.prefix + '/org/examPaperScoreByTeacher/' + examId + '/' + paperId})
    },
    deleteScore (examId) {
      var that = this
      this.confirmBox({
        title: '删除',
        text: '确认删除这条考试记录吗？',
        yes: function () {
          that.$api.post(that.$global.examApiPath, '/examExamScore/delete', {
            id: examId
          }, r => {
            that.$toasted.show('已删除')
            that.getExamScore(that.filter)
            that.$modal.hide('dialog')
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_paper/scoreList.vue